import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-edit-accountoptions',
  templateUrl: './edit-accountoptions.component.html',
  styleUrls: ['./edit-accountoptions.component.scss']
})
export class EditAccountoptionsComponent implements OnInit {
  finishedLoading: boolean = false;
  editForm: FormGroup;
  userID:string;
  currentAccountOptions;
  public states = [
    { value: 'NEW', viewValue: 'Neu' },
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'DISABLED', viewValue: 'Deaktiviert'},
    { value: 'DISABLED', viewValue: 'Gelöscht'}
  ];


  constructor(private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private fb: FormBuilder,
    private router:Router,
    private overlayService:OverlayService) {
    this.editForm = this.fb.group({
      optionName: ['', [Validators.required]],
      description: ['', []],
      displayName: ['', [Validators.required]],
      state: ['', [Validators.required]]
    })
  }



  ngOnInit(): void {
    this.route.params.subscribe(params => {
      console.log(params)
      this.businessuserService.getAccountOptionsForAccount(params['id']).subscribe((options: Array<any>) => {
        this.userID = params['id'];
        options.forEach(element => {
          if (element.accountOption.id == params['aid']) {
            this.currentAccountOptions = element;
            this.editForm.patchValue({
              optionName : element.accountOption.optionName,
              description:element.accountOption.description,
              displayName: element.accountOption.displayName,
              state : element.accountOption.state
            })
          }
        });
        this.finishedLoading = true;
      })
    })
  }


  movebacktoOverview() {
    this.router.navigateByUrl(`caseworker/accountoptions/${this.userID}`)
  }

  editAccountOptions(){
    this.editForm.markAllAsTouched();

    if(this.editForm.invalid){
      return
    }

    // this.currentAccountOptions.accountOption.optionName = this.editForm.getRawValue().optionName;
    // this.currentAccountOptions.accountOption.description = this.editForm.getRawValue().description;
    // this.currentAccountOptions.accountOption.displayName = this.editForm.getRawValue().displayName;
    // this.currentAccountOptions.accountOption.state = this.editForm.getRawValue().state;


    // this.businessuserService.editAccountOptionsForAccount(this.userID, this.currentAccountOptions).subscribe(fromEdit=>{
    //   this.overlayService.openSnackBar("Zusatzfunktion erfolgreich geändert!");
    //   this.movebacktoOverview();
    // })
  }
}
